export function currency(value) {
    // price integer de centavos. ex: 1000 = 10,00
    value = Number(value) / 100
    let string = value.toFixed(2)
    string = string.replace('.', ',')
    return 'R$' + string
}
